import multiselectSearchHelper from './multiselectSearchHelper';

const addressFormatter = (item, boldFormattedItem) => {
  let result = '';
  const plz = item.plz ? `${item.plz}` : '';
  const citySpace = plz ? ' ' : '';
  const city = item.city ? `${citySpace}${item.city}` : '';
  const plzCity = plz || city ? ` (${plz}${city})` : '';
  switch (item.type) {
    case 'city': {
      result = boldFormattedItem || item.city;
      break;
    }
    case 'plz': {
      let plzNum;
      if (boldFormattedItem) plzNum = boldFormattedItem ? `${boldFormattedItem}` : '';
      else plzNum = item.plz ? `${item.plz}` : '';
      const cityPlz = item.city ? ` (${item.city})` : '';
      result = `${plzNum}${cityPlz}`;
      break;
    }
    case 'colony': {
      let colony;
      if (boldFormattedItem) colony = boldFormattedItem ? `${boldFormattedItem}` : '';
      else colony = item.colony ? `${item.colony}` : '';
      result = `${colony}${plzCity}`;
      break;
    }
    case 'district': {
      let district;
      if (boldFormattedItem) district = boldFormattedItem ? `${boldFormattedItem}` : '';
      else district = item.district ? `${item.district}` : '';
      result = `${district}${plzCity}`;
      break;
    }
    case 'address': {
      let address;
      if (boldFormattedItem) address = boldFormattedItem ? `${boldFormattedItem}` : '';
      else address = item.address ? `${item.address}` : '';
      result = `${address}${plzCity}`;
      break;
    }
    default: break;
  }
  return result;
};

const addressSearchResultMapper = (pattern, searchData, updateItems) => {
  let resultItems = [];
  searchData.forEach((item) => {
    switch (item.type) {
      case 'city':
        resultItems.push(multiselectSearchHelper.boldMatchedPattern(pattern, item.city, item));
        break;
      case 'plz':
        resultItems.push(multiselectSearchHelper.boldMatchedPattern(pattern, item.plz, item));
        break;
      case 'colony':
        resultItems.push(multiselectSearchHelper.boldMatchedPattern(pattern, item.colony, item));
        break;
      case 'address':
        resultItems.push(multiselectSearchHelper.boldMatchedPattern(pattern, item.address, item));
        break;
      case 'district':
        resultItems.push(multiselectSearchHelper.boldMatchedPattern(pattern, item.district, item));
        break;
      default: break;
    }
  });
  resultItems = resultItems.map((item) => {
    const obj = {};
    obj.displayName = addressFormatter(item.item, item.displayName);
    obj.value = addressFormatter(item.item);
    obj.data = {
      ...item.item,
      resultType: item.item.label,
    };
    return obj;
  });
  updateItems(resultItems);
};

const addressSelectedItemsMapper = (item) => {
  const formattedItem = addressFormatter(item.data);
  return {
    displayName: formattedItem,
    value: formattedItem,
    data: item.data,
  };
};

export default {
  addressSearchResultMapper,
  addressSelectedItemsMapper,
  addressFormatter,
};
